import { theme as baseTheme } from '@chakra-ui/react'

export const fonts = {
  heading: `Montserrat, ${baseTheme.fonts.heading}`,
  body: `Montserrat, ${baseTheme.fonts.body}`,
  mono: `Montserrat, ${baseTheme.fonts.mono}`,
}
